import React, { useState } from "react";
import {
  makeStyles,
  Grid,
  Badge,
  CircularProgress,
  Dialog,
  DialogTitle,
} from "@material-ui/core";
import { uploadFile, uploadImage } from "../../ApiHelper";
import CancelIcon from "@material-ui/icons/Cancel";
import CameraAltIcon from "@material-ui/icons/CameraAlt";

const useStyles = makeStyles((theme) => ({
  input: {
    border: "none",
    borderBottom: "1px solid #e9e9e9",
    width: "100%",
    height: 40,
    fontSize: 12,
  },
  label: {
    width: "100%",
    color: "#1075c2",
    margin: 0,
    fontSize: 13,
    marginTop: 20,
  },
  button: {
    color: "white",
    border: "none",
    borderRadius: 15,
    width: "80%",
    background: "#1075c2",
    height: 45,
    marginTop: 20,
  },
  heading: {
    fontSize: 16,
    margin: 0,
    marginTop: 10,
    fontWeight: 600,
  },
  icon: { marginTop: 10, fontSize: 16, color: "#2d86c9" },
  labelBlack: {
    width: "100%",
    margin: 0,
    fontSize: 13,
    marginTop: 10,
  },
  image: {
    width: 100,
    height: 100,
    borderRadius: 5,
    marginRight: 15,
  },
}));

const DescriptionAndPhoto = (props) => {
  const [uploadVideo, setUploadVideo] = useState(false);
  const [open, setOpen] = useState(false);
  // const [uploadedImages, setUploadedImages] = useState([]);
  const classes = useStyles();

  const handleClose = () => {
    setOpen(false);
  };

  const onChangeFile = async (event) => {
    const files = Array.from(event.target.files);
    const newUploadedImages = [];

    try {
      setUploadVideo(true);
      for (const file of files) {
        console.log("uploading image", file.name);
        // var data = new FormData();
        // data.append("image", file);
        //const response = await uploadFile(data);
        const response = await uploadImage(file);
        console.log("file uploaded =", response);

        newUploadedImages.push(response.data); // Display the uploaded image
        //newUploadedImages.push(URL.createObjectURL(file)); // Display the uploaded image
      }
      const updatedImages = [...props.images, ...newUploadedImages];
      props.setRequestData("image", updatedImages);
      localStorage.setItem("image", JSON.stringify(updatedImages));
      //setUploadedImages((prevImages) => [...prevImages, ...newUploadedImages]);
      setUploadVideo(false);
      setOpen(true);
    } catch (e) {
      console.log("file upload error =", e);
      setUploadVideo(false);
    }
  };

  const handleRemoveImage = (imageUrl) => {
    const updatedImages = props.images.filter((img) => img !== imageUrl);
    props.setRequestData("image", updatedImages);
    localStorage.setItem("image", JSON.stringify(updatedImages));
  };

  return (
    <Grid
      container
      direction="row"
      justify="center"
      style={{ padding: 20, height: "max-content" }}
    >
      <p style={{ textAlign: "justify" }}>
        Briefly describe your problem, please do not input any sensitive
        information here.
      </p>
      <textarea
        className={classes.input}
        style={{
          resize: "none",
          border: "1px solid #efefef",
          borderRadius: 20,
          height: 100,
          padding: 10,
        }}
        value={props.description}
        onChange={(e) => {
          localStorage.setItem("description", e.target.value);
          props.setRequestData("description", e.target.value);
        }}
      ></textarea>
      {uploadVideo ? <CircularProgress /> : ""}
      {/* {open && (
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            style={{ color: "black", fontWeight: "bold" }}
          >
            {"Image(s) uploaded"}
          </DialogTitle>
        </Dialog>
      )} */}
      <p className={classes.label}>Add Photos</p>
      <div style={{ width: "100%", marginTop: 20 }}>
        <input
          type="file"
          name="image"
          id="images"
          multiple
          className="form-control"
          style={{ display: "none" }}
          onChange={(e) => {
            console.log(e.target.files);
            onChangeFile(e);
          }}
        />
        <Grid container direction="row" alignItems="center">
          {props.images.map((image, index) => {
            console.log("Displaying image:", image);
            return (
              <Badge
                key={index}
                badgeContent={
                  <CancelIcon
                    style={{ color: "red", marginLeft: -40 }}
                    onClick={() => handleRemoveImage(image)}
                  />
                }
              >
                <img
                  src={image}
                  className={classes.image}
                  alt={`uploaded-${index}`}
                />
              </Badge>
            );
          })}
          <Grid
            style={{
              width: 100,
              height: 100,
              background: "#efefef",
              borderRadius: 5,
            }}
            container
            direction="row"
            justify="center"
            alignItems="center"
            onClick={() => {
              document.getElementById("images").click();
            }}
          >
            <CameraAltIcon />
          </Grid>
        </Grid>
        <div
          style={{
            width: "95vw",
            borderBottom: "1px solid #e9e9e9",
            display: "flex",
            bottom: 0,
            height: 70,
          }}
        >
          <Grid item md={6} xs={6}>
            <button
              className={classes.button}
              style={{
                height: 35,
                padding: 5,
                paddingLeft: 10,
                paddingRight: 10,
                marginRight: 10,
                fontSize: 11,
                borderRadius: 10,
                width: "95%",
                background: "#f2f2f2",
                color: "black",
              }}
              onClick={() => {
                props.setActiveTab("Property");
              }}
            >
              Prev
            </button>
          </Grid>
          <Grid item md={6} xs={6}>
            <button
              className={classes.button}
              style={{
                height: 35,
                padding: 5,
                paddingLeft: 10,
                paddingRight: 10,
                marginRight: 10,
                fontSize: 11,
                borderRadius: 10,
                width: "95%",
              }}
              onClick={() => {
                props.setActiveTab("Insurance");
              }}
            >
              Next
            </button>
          </Grid>
        </div>
      </div>
    </Grid>
  );
};

export default DescriptionAndPhoto;
